import type { Metadata } from '@measured/puck';

import { AnswersByRespondentType } from './survey-types';

type PuckReportMetadata = {
  readonly answers?: AnswersByRespondentType;
  readonly piSystemId: string;
  readonly healthcareSystemLookupId?: string;
  readonly healthcareSystemPatientId?: string;
  readonly healthcareLookupPerformed: boolean;
  readonly isPdf?: boolean;
  readonly webReportUrl?: string;
  readonly reportStatus?: string;
  readonly reportTimestamp?: string;
  readonly respondents: { respondentType: string; complete: boolean; completedAt?: string | Date | null }[];
};

const isPuckReportMetadata = (metadata: Metadata): metadata is PuckReportMetadata => {
  const { piSystemId } = metadata;

  return typeof piSystemId === 'string' && piSystemId.length > 0;
};

const getReportMetadata = (metadata: Metadata): PuckReportMetadata | undefined =>
  isPuckReportMetadata(metadata) ? metadata : undefined;

export { getReportMetadata, type PuckReportMetadata };
